import { render, staticRenderFns } from "./BiometricsEditModal.vue?vue&type=template&id=76da7197"
import script from "./BiometricsEditModal.vue?vue&type=script&lang=js"
export * from "./BiometricsEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports